import { FormikHelpers } from "formik";
import { useContext } from "react";
import { SydFilterContext } from "src/components/Common/UI/SydFilter/SydFilterContext";
import { isTypeOfDataLineSearchForm } from "src/components/Common/UI/SydFilter/SydFilterTypeChecker";
import DataLineSearchForm from "./DataLineSearchForm";


const emptyDataLineSearchForm: IDataLineSearchForm = {
  descline: "",
  hcNmsNum: "",
  providerID: "",
  sapCode: "",
  phoneNumber: "",
  pendingStatusID: "",
  speedID: "",
  lineTypeID: "",
  deleted: "",
  removalDateFrom: "",
  removalDateTo: "",
  comments: ""
}

const SearchPhoneLines = () => {
  const sydFilterCtx = useContext(SydFilterContext);

  const activeFilters = sydFilterCtx.activeFilters;
  const clearForm = sydFilterCtx.clearAllFilters;
  const saveFilters  = sydFilterCtx.saveFilters;
  const handleClose = sydFilterCtx.toggleFilterVisibility;

  const initialValues = isTypeOfDataLineSearchForm(activeFilters) ? activeFilters as IDataLineSearchForm : emptyDataLineSearchForm;

  const handleSubmit = async (values: IDataLineSearchForm, { setSubmitting }: FormikHelpers<IDataLineSearchForm>): Promise<void> => {
    saveFilters(values);
    setSubmitting(false);
    handleClose();
  }

  return (
    <DataLineSearchForm initialValues={initialValues} onSubmit={handleSubmit} onClearForm={clearForm} />
  )
}

export default SearchPhoneLines;